import { TSubcategory } from '../multipleCategories'

export const checkIsCategoryInBusinessUnit = (subcategory: TSubcategory, businessUnit: string) =>
  subcategory.title.startsWith(businessUnit)
